import React, { Fragment, FC } from "react";
import SingleNotificationItem from "../SingleNotificationItem";
import { Query_shared } from "@/api/shared";
import readAllMessages from "../../helperFunctions/readAllMessages";
import { ErrorFallback } from "@/components";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, Text } from "@radix-ui/themes";

type Props = {
  loading: boolean;
  isFullPage?: boolean;
  notifications?: any;
  setDropdownOpen: any;
  unreadNotifications: number;
  updateNotifications: any;
};

const NotificationsList: FC<Props> = ({
  notifications,
  isFullPage,
  loading,
  setDropdownOpen,
  unreadNotifications,
  updateNotifications,
}): JSX.Element => {
  const navigate = useNavigate();

  try {
    return (
      <>
        {notifications && (
          <>
            <div className="notifications__list">
              {notifications
                .sort(
                  (a: any, b: any) =>
                    a.data.createdAt.seconds - b.data.createdAt.seconds
                )
                // .reverse()
                .slice(0, isFullPage ? 25 : 5)
                .map((doc: any) => {
                  return (
                    <Fragment key={doc.realtimeDocumentID}>
                      <SingleNotificationItem
                        data={doc.data}
                        docId={doc.realtimeDocumentID}
                        whenWasSent={Query_shared.getWhenWasPosted(
                          doc.data.createdAt._seconds * 1000
                        )}
                      />
                    </Fragment>
                  );
                })}
            </div>
          </>
        )}

        {isFullPage && (
          <Text size="1">
            Read notifications are automatically deleted after 10 days.
          </Text>
        )}

        <div className="notifications__actions">
          <DropdownMenu.Separator />
          {!isFullPage && unreadNotifications !== 0 && (
            <DropdownMenu.Item
              onClick={async () =>
                await readAllMessages(notifications).then(() => {
                  updateNotifications();
                })
              }
            >
              Mark all as read
            </DropdownMenu.Item>
          )}
          {!isFullPage && (
            <DropdownMenu.Item
              onClick={() => {
                navigate("/notifications");
              }}
            >
              See all notifications
            </DropdownMenu.Item>
          )}
        </div>
      </>
    );
  } catch {
    return <ErrorFallback>Error fetching Notifications</ErrorFallback>;
  }
};

export default React.memo(NotificationsList);
